import { useContext } from 'react'
import { BillingContext } from '../context/Billing.context'

export const useOrgBilling = () => {
  const billingContext = useContext(BillingContext)
  return billingContext
}
